exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".top-menu-cbx-logo {\n  max-height: 30px; }\n\n.img-external-border {\n  border: 3px solid white;\n  border-radius: 4px;\n  margin-left: 10px;\n  margin-top: 3px; }\n\n.img-internal-border {\n  border: 2px solid #FF6A6A;\n  border-radius: 4px !important;\n  background-color: white;\n  padding: 4px; }\n\n.toolbar-tpv {\n  border-bottom: 4px solid #FF6A6A;\n  background-color: #FF6A6A !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/scss/top-menu.scss
// module id = 685
// module chunks = 0